import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-icons',
	templateUrl:'./FontAwesomeIconsPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeIconsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeIconsPluginCompPage
{
	mdContent_930 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.icons.FontAwesomeIcons;
\`\`\``;
	mdContent_931 = `\`\`\`java
new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.home);
new FontAwesome<>(FontAwesomeStyles.Classic, FontAwesomeIcons.cog);
new FontAwesome<>(FontAwesomeStyles.Filled, FontAwesomeIcons.star);
\`\`\``;
}
